import { render, staticRenderFns } from "./p02.vue?vue&type=template&id=67dbd670&scoped=true&"
import script from "./p02.vue?vue&type=script&lang=js&"
export * from "./p02.vue?vue&type=script&lang=js&"
import style0 from "./p02.vue?vue&type=style&index=0&id=67dbd670&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dbd670",
  null
  
)

export default component.exports